import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight, FiCheck } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Seo from "../chrome/Seo";
import Metrics from "../sections/Metrics";
import CapGrid from "../sections/CapGrid";
import Atlas from "../sections/Atlas";
import Approach from "../sections/Approach";
import Invite from "../sections/Invite";
import copy from "../lib/copy";

const Home = () => (
  <Frame>
    <Seo />

    <section className="hero">
      <div className="shell">
        <div className="layout">
          <div>
            <span className="eyebrow">Marketing studio · International brands → Türkiye</span>
            <h1>
              International brands, <span className="accent">launched&nbsp;properly</span> in Türkiye.
            </h1>
            <p className="lede" style={{ marginTop: "1.5rem" }}>
              {copy.blurb}
            </p>
            <div className="signature">
              <Link to="/services" className="btn btn--primary">
                See what we do <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn btn--line">
                Talk to the team
              </Link>
            </div>
          </div>

          {/* Right-side bento */}
          <div className="bento">
            <div className="tile tile--feature">
              <span className="tag">Featured</span>
              <div>
                <div className="num">11</div>
                <div className="lbl">Capabilities under one accountable producer — from market entry to local customer care.</div>
              </div>
            </div>
            <div className="tile">
              <div className="num">9</div>
              <div className="lbl">Sectors actively served across consumer + B2B.</div>
            </div>
            <div className="tile">
              <div className="num">100%</div>
              <div className="lbl">TR-native bilingual team. No relay race.</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Metrics />

    {/* Why Vitalis */}
    <section className="band">
      <div className="shell">
        <div className="duet">
          <div>
            <span className="eyebrow">Why Vitalis</span>
            <h2>One studio for the whole Türkiye launch — strategy, media, retail, operations.</h2>
            <p>
              International brands lose more in Türkiye to fragmentation than to strategy. A media agency here, a PR agency
              there, a distributor handling retail, a freelancer translating copy, and no one accountable for the result
              the global team is being measured on.
            </p>
            <p>
              Vitalis brings all of it under one roof. The same senior team writes your Türkiye go-to-market, runs your
              paid media, owns your social and PR, activates retail and marketplace, and operates your local customer care —
              measured against one set of business KPIs, reported in TR and EN every month.
            </p>
            <ul className="tick-list">
              <li><span className="mark"><FiCheck /></span> One accountable team for strategy, media, retail, PR and operations</li>
              <li><span className="mark"><FiCheck /></span> Senior-led delivery; no junior pass-through on the work that matters</li>
              <li><span className="mark"><FiCheck /></span> Bilingual (TR + EN) at every level — briefs, reports and reviews</li>
              <li><span className="mark"><FiCheck /></span> Independent of media kickbacks and distributor commissions</li>
            </ul>
          </div>

          <div className="stat-card">
            <div className="big"><em>40+</em></div>
            <div className="lbl">International brands launched in Türkiye across FMCG, fashion, beauty, food &amp; beverage, tech, automotive and travel.</div>
            <div className="grid-meta">
              <div>
                <div className="k"><span className="pip" />9 sectors</div>
                <div className="v">Active playbooks</div>
              </div>
              <div>
                <div className="k"><span className="pip" />24/7</div>
                <div className="v">Social moderation SLA</div>
              </div>
              <div>
                <div className="k"><span className="pip" />TR + EN</div>
                <div className="v">Bilingual reporting</div>
              </div>
              <div>
                <div className="k"><span className="pip" />Belgrade</div>
                <div className="v">Studio HQ</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* What we do — bento capabilities */}
    <section className="band band--soft">
      <div className="shell">
        <div className="section-title section-title--left">
          <span className="eyebrow">What we do</span>
          <h2>Eleven capabilities, one accountable producer.</h2>
          <p style={{ maxWidth: 720 }}>From the first market read through to the second-year scale plan, each workstream is led by a senior at Vitalis — not subcontracted out.</p>
        </div>
        <CapGrid />
        <div style={{ marginTop: "2.5rem" }}>
          <Link to="/services" className="btn btn--ink">
            All eleven capabilities <FiArrowUpRight />
          </Link>
        </div>
      </div>
    </section>

    {/* How we work — dark with lime dots */}
    <section className="band band--ink">
      <div className="shell">
        <div className="duet">
          <div>
            <span className="eyebrow eyebrow--light">How we work</span>
            <h2 style={{ color: "white" }}>A deliberate, four-phase engagement model.</h2>
            <p>
              Türkiye launches are rarely won in a single quarter. Our model is paced for that reality: we measure twice,
              sequence carefully, and stay involved long enough to see year-two compound.
            </p>
          </div>
          <div>
            <Approach />
          </div>
        </div>
      </div>
    </section>

    {/* Sectors */}
    <section className="band">
      <div className="shell">
        <div className="section-title section-title--left">
          <span className="eyebrow">Sectors</span>
          <h2>Active across the categories where international brands actually scale.</h2>
          <p style={{ maxWidth: 720 }}>We work with brand teams across the sectors below — each with its own commercial, regulatory and creative playbook in Türkiye.</p>
        </div>
        <Atlas />
      </div>
    </section>

    <Invite />
  </Frame>
);

export default Home;
